import { render } from "./BlogWidgets.vue?vue&type=template&id=04e5c4e1&scoped=true"
import script from "./BlogWidgets.vue?vue&type=script&lang=js"
export * from "./BlogWidgets.vue?vue&type=script&lang=js"

import "./BlogWidgets.vue?vue&type=style&index=0&id=04e5c4e1&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e5c4e1"]])

export default __exports__